// eslint-disable-next-line import/prefer-default-export
export const StudyTypes = {
  ADD_STUDY: 'ADD_STUDY',
  ADD_CONTENT: 'ADD_CONTENT',
  ADD_ACTIVE_STUDY: 'ADD_ACTIVE_STUDY',
  COMPLETE: 'COMPLETE',
  ADD_CONTENT_ID: 'ADD_CONTENT_ID',
};
